import ParkingCard from '@components/ParkingCard/ParkingCard.component'
import React, { ReactNode } from 'react'
import {
    CardBodyMainContainer,
    CardBodyMainContainerSubtitle,
    CardBodyMainContainerTitle,
    CardBodyMainInfoText
} from './CarpayOrderCard.style'
import { formatPriceWithCurrency } from '@utils/formatPriceWithCurrency.utils'
import { priceToString } from '@utils/priceToString.utils'

interface CardContentProps {
    title: string
    subtitle?: string | ReactNode
    price: number
    discount?: ReactNode
    currency: string
}

const CarpayOrderCardContent = ({ title, subtitle, price, discount, currency }: CardContentProps) => (
    <ParkingCard.Content>
        {discount}
        <ParkingCard.InnerContent>
            <CardBodyMainContainer>
                <CardBodyMainContainerTitle>{title}</CardBodyMainContainerTitle>
                <CardBodyMainContainerSubtitle>{subtitle}</CardBodyMainContainerSubtitle>
            </CardBodyMainContainer>
            <CardBodyMainInfoText>
                {price ? formatPriceWithCurrency(currency).format(priceToString(price)) : '- €'}
            </CardBodyMainInfoText>
        </ParkingCard.InnerContent>
    </ParkingCard.Content>
)

export default CarpayOrderCardContent
